import styled from '@emotion/styled';
import StyledModal from '@components/Modal';
import StyledButton from '@components/Button';
import STRINGS from '@utils/strings';

const Title = styled.div(({ theme }) => ({
    ...theme.typography.h6,
    marginBottom: theme.spacing.xs,
    display: 'flex',
    justifyContent: 'center'
}));

const ButtonContainer = styled.div(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-evenly',
    margin: 'auto',
    marginTop: theme.spacing.s
}));

function StyledConfirmationModal({ show, onClose, children }) {
    return (<>
        <StyledModal show={show} onClose={onClose}>
            <Title>{STRINGS.error}</Title>
            {children}
            <ButtonContainer>
                <StyledButton onClick={onClose}>{STRINGS.close}</StyledButton>
            </ButtonContainer>
        </StyledModal>
    </>);
}

export default StyledConfirmationModal;
